import {
    SIGNAL_FILE_UPLOAD_REQUEST,
    SIGNAL_FILE_UPLOAD_RESET,
    SIGNAL_FILE_UPLOAD_FAIL,
    SIGNAL_FILE_UPLOAD_SUCCESS,
    SIGNAL_DELETE_FAIL,
    SIGNAL_DELETE_REQUEST,
    SIGNAL_DELETE_RESET,
    SIGNAL_DELETE_SUCCESS,
    SIGNAL_DETAILS_FAIL,
    SIGNAL_DETAILS_REQUEST,
    SIGNAL_DETAILS_SUCCESS,
    SIGNAL_LIST_FAIL,
    SIGNAL_LIST_REQUEST,
    SIGNAL_LIST_SUCCESS,
    SIGNAL_UPDATE_DETAILS_FAIL,
    SIGNAL_UPDATE_DETAILS_REQUEST,
    SIGNAL_UPDATE_DETAILS_RESET,
    SIGNAL_UPDATE_DETAILS_SUCCESS,
} from '../constants/signalConstants';

export const signalListReducer = (state = { signalList: [] }, action) => {
    switch (action.type) {
        case SIGNAL_LIST_REQUEST:
            return { loading: true, signalList: [] };
        case SIGNAL_LIST_SUCCESS:
            return { loading: false, signalList: action.payload };
        case SIGNAL_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const signalCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case SIGNAL_FILE_UPLOAD_REQUEST:
            return { loading: true };
        case SIGNAL_FILE_UPLOAD_SUCCESS:
            return { loading: false, message: action.payload };
        case SIGNAL_FILE_UPLOAD_FAIL:
            return { loading: false, error: action.payload };
        case SIGNAL_FILE_UPLOAD_RESET:
            return { loading: false, message: null, error: null };
        default:
            return state;
    }
};

export const signalDetailsReducer = (state = { signal: {} }, action) => {
    switch (action.type) {
        case SIGNAL_DETAILS_REQUEST:
            return { ...state, loading: true };
        case SIGNAL_DETAILS_SUCCESS:
            return { loading: false, signal: action.payload };
        case SIGNAL_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const signalUpdateDetailsReducer = (state = { signal: {} }, action) => {
    switch (action.type) {
        case SIGNAL_UPDATE_DETAILS_REQUEST:
            return { loading: true };
        case SIGNAL_UPDATE_DETAILS_SUCCESS:
            return { loading: false, success: true, signal: action.payload };
        case SIGNAL_UPDATE_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case SIGNAL_UPDATE_DETAILS_RESET:
            return { signal: {} };
        default:
            return state;
    }
};

export const signalDeleteReducer = (state = { success: false }, action) => {
    switch (action.type) {
        case SIGNAL_DELETE_REQUEST:
            return { loading: true, ...state };
        case SIGNAL_DELETE_SUCCESS:
            return { loading: false, success: true };
        case SIGNAL_DELETE_FAIL:
            return { loading: false, success: false, error: action.payload };
        case SIGNAL_DELETE_RESET:
            return { loading: false, success: false, error: null };
        default:
            return state;
    }
};
